import aboutUsImage from "../../../assets/images/about-us.jpg";
import DETAILS from "../../../constants/about";
import { SECTIONIDS } from "../../../constants/sectionId";

const AboutUsSection = () => {
  return (
    <section
      id={SECTIONIDS.ABOUT}
      className="relative z-10 bg-black pb-20 pt-32 md:pb-0  lg:pb-0 md:pt-40"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-12 xl:px-6 2xl:px-0">
        <div
          data-rellax-speed="0"
          data-rellax-xs-speed="0"
          data-rellax-mobile-speed="0"
          className="rellax flex flex-wrap items-center gap-6"
          style={{ transform: "translate3d(0px, 0px, 0px)" }} // Changed to object syntax
        >
          <h2 className="text-7xl font-bold text-white xl:text-8xl">
            About us
          </h2>
          <span className="h-max rounded-full border border-white/40 px-2 py-1 text-xs tracking-wider text-white">
            Erom Studio
          </span>
        </div>
        <div className="mt-24 md:mt-16">
          <div className="grid gap-6">
            <div className="grid md:grid-cols-3">
              <div className="overflow-hidden md:col-span-2">
                <img
                  src={aboutUsImage}
                  alt="About Us"
                  width="1500"
                  height="1000"
                />
              </div>
            </div>
            <div
              data-rellax-speed="2"
              data-rellax-xs-speed="0"
              data-rellax-mobile-speed="0"
              data-rellax-tablet-speed="0.5"
              className="rellax ml-auto md:w-3/5 lg:w-2/5"
              style={{ transform: "translate3d(0px, 0px, 0px)" }} // Changed to object syntax
            >
              <p className="mt-12 text-2xl font-light text-white">
                {DETAILS.about}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;
